import styled, { Scale } from '@secretescapes/falcon';

export const ButtonsWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${Scale.xs};
`;

export const IconsBox = styled('div')`
  display: grid;
  grid-template-columns: auto auto;
  gap: ${Scale.m};
`;
